import React from 'react';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { SpecifiedEntityFormValues } from '../../modals/SpecifiedEntityExclusionModal';
import { SpecifiedEntityExclusionModalConfig } from '../../modals/SpecifiedEntityExclusionModal';
import type { EventExclusions } from '../../../../../../api/types/rater-x-preset';

const SpecifiedEntityExclusion = (
  props: AmendatoryLineItemProps & { showDescription: boolean }
) => {
  const handleAddExclusion = (formValues: SpecifiedEntityFormValues) => {
    const _exclusions = formatExclusionsForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: {
          exclusions: { values: _exclusions as unknown as EventExclusions[] },
        },
      },
    });
  };

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(SpecifiedEntityExclusionModalConfig, {
          data: {
            onSubmit: handleAddExclusion,
            showDescription: props.showDescription,
            exclusions: getDefaultExclusionValues(
              props.value?.props?.exclusions?.values as EventExclusions[]
            ),
          },
        })}
      >
        Add/Edit ({String(props.value?.props?.exclusions?.values?.length ?? 0)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default SpecifiedEntityExclusion;

export function getDefaultExclusionValues(
  values: EventExclusions[] | undefined
) {
  if (!values) {
    return [];
  }

  return values.map((value) => {
    return {
      name: value.props.name.value ?? '',
      description: value.props.description?.value ?? '',
    };
  });
}

export function formatExclusionsForState(
  formValues: SpecifiedEntityFormValues
) {
  return formValues.exclusions.map((exclusion) => {
    return {
      props: Object.keys(exclusion).reduce((acc, key) => {
        const value = exclusion[key as keyof typeof exclusion];
        return {
          ...acc,
          [key]: { value },
        };
      }, {} as EventExclusions),
    };
  });
}
